import React from 'react';
import { useSelector } from 'react-redux';

import UserSessionPanel from '../UserSessionPanel';
import hb from 'images/shb-large-logo.svg';
import Reports from 'components/Reports';
import { selectIsPremiumAccount } from '../../state/user/selectors';
import HeaderMenu from './HeaderMenu';

if (process.env.NODE_ENV !== 'test') {
  require('./Header.scss');
}

const Header = () => {
  const isPremiumAccount = useSelector(selectIsPremiumAccount);

  return (
    <>
      <header data-test-id="pageHeader" className="hidden-print">
        {/* Mobile logo */}
        <div className="logo-container visible-xs">
          <img className="logo" src={hb} alt="Handelsbanken logo" />
          <UserSessionPanel />
        </div>

        <div className="user-panel hidden-xs">
          <div>
            <Reports />
            <UserSessionPanel />
          </div>
        </div>

        {/* Desktop logo */}
        <div className="logo-container hidden-xs">
          <img className="logo" src={hb} alt="Handelsbanken logo" />
          <div className="prime" data-test-id="logoText">
            <p>{isPremiumAccount ? 'Premium' : 'Prime'}</p>
          </div>
        </div>
        <HeaderMenu />
      </header>

      {/* Stupid print styling */}
      <header className="visible-print">
        <div className="user-panel">
          <div>
            <UserSessionPanel />
          </div>
        </div>
        <div className="logo-container">
          <img className="logo" src={hb} alt="Handelsbanken logo" />
          <div className="prime" data-test-id="logoText">
            <p>{isPremiumAccount ? 'Premium' : 'Prime'}</p>
          </div>
        </div>
      </header>
    </>
  );
};
export default Header;
